import { BrowserRouter, Route, Routes } from "react-router-dom";
import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import "./App.css";
// import Login from './user/component/auth/Login';
import {
  BILL_HISTORY,
  CANCLE,
  CARD,
  HISTORY,
  HOME,
  INVOICE,
  INVOICE_PENDING,
  GLOBLE_SEARCH,
  INVOICE_NEED_ACTION,
  FORGOT_PASSWORD,
  INVOICE_READY_APPROVAL,
  INVOICE_VIEW,
  LOGIN,
  NOTIFY,
  FEEDBACK,
  REPORT,
  STRIPE,
  INV_APPROVAL,
  INV_APPROVAL_VIEW,
  REGISTER,
  INVOICE_CLAIM,
  SUCCESS,
  PRIVACYPOLICY,
  TERMSOFUSE,
  TEAM,
  PASSWORDSETUP,
  ONBOARDINGSETUP,
  USERTEAMPASSWORDSETUP,
  PENDING_INFO,
  DENIED,
  FINALIZED,
  ANALYTICS,
  CLAIM_ACTIVE_VIEW,
  DASHBOARD,
} from "./services/UserRoutePath";
import UserProtected from "./user/component/protected/UserProtected";
// import Home from './user/component/layout/Home'
import {
  ADMIN,
  ADMIN_COMPLETED_INVOICE,
  ADMIN_DASHBOARD,
  ADMIN_CLAIM,
  ADMIN_INVOICE,
  ADMIN_INVOICE_COMPLETED_VIEW,
  ADMIN_INVOICE_VIEW,
  ADMIN_JOB_TYPE,
  ADMIN_LOGIN,
  ADMIN_NOTIFICATION,
  ADMIN_ORDERS,
  ADMIN_PAYMENT,
  ADMIN_STATUS,
  ADMIN_TEAM,
  ADMIN_USER,
  ADMIN_VIEW_ORDERS,
  ADMIN_CLAIM_DASHBOARD,
  ADMIN_CLAIM_COMPLETED_JOB,
  ADMIN_CLAIM_ACTIVE_JOB,
  ADMIN_CLAIM_CLIENT,
  ADMIN_CLAIM_USER,
  ADMIN_CLAIM_REPORT,
  ADMIN_CLAIM_COMPLETED_JOB_VIEW,
  ADMIN_CLAIM_ACTIVE_JOB_VIEW,
  ADMIN_INTERNAL_NOTE_VIEW,
  ADMIN_FEEDBACK,
  ADMIN_DELETE_PIN,
} from "./services/AdminRoutePath";
// import AdminHome from './admin/component/layout/AdminHome';
import AdminAuthProvider from "./admin/context/AdminAuthProvider";
import AdminProtected from "./admin/component/protected/AdminProtected";
import "react-toastify/dist/ReactToastify.css";
import UserAuthProvider from "./user/component/context/UserAuthProvider";
import SucessfullPage from "./user/component/page/SucessfullPage";
import TermOfUse from "./user/component/page/TermOfUse";
import PrivacyPolicy from "./user/component/page/PrivacyPolicy";
import CanclePage from "./user/component/page/CanclePage";
import { Suspense, lazy } from "react";
import { QueryClient, QueryClientProvider } from "react-query";
import NotFound from "./user/component/page/NotFound";

import { getLoggedInAdmin } from "./services/AdminLocalStorage";

const Login = lazy(() => import("./user/component/auth/Login"));
const Register = lazy(() => import("./user/component/auth/Register"));
const ForgotPassword = lazy(() =>
  import("./user/component/auth/forgotPassword")
);
const PasswordSetup = lazy(() =>
  import("./user/component/auth/password_setup")
);
const OnboardingSetup = lazy(() =>
  import("./user/component/auth/onboarding_setup")
);
const UserTeamPasswordSetup = lazy(() =>
  import("./user/component/auth/user_team_password_setup")
);
// const TermOfUse = lazy(() => import ("./user/component/page/TermOfUse"))
// const PrivacyPolicy = lazy(() => import ("./user/component/page/PrivacyPolicy"))
const Home = lazy(() => import("./user/component/layout/Home"));
const AdminHome = lazy(() => import("./admin/component/layout/AdminHome"));
const queryClient = new QueryClient();
const admin = getLoggedInAdmin();
function MyComponent() {
  useEffect(() => {
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.async = true;
    script.innerHTML = `
      window.smartlook||(function(d) {
        var o=smartlook=function(){ o.api.push(arguments)},h=d.getElementsByTagName('head')[0];
        var c=d.createElement('script');o.api=new Array();c.async=true;c.type='text/javascript';
        c.charset='utf-8';c.src='https://web-sdk.smartlook.com/recorder.js';h.appendChild(c);
      })(document);
      smartlook('init', 'bb8e0f04d0f970f9de9d5b34633182942e0c993c');
    `;
    document.head.appendChild(script);
  }, []);

  return;
}

if (!admin) {
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(<MyComponent />);
}
function App() {
  return (
    <>
      <QueryClientProvider client={queryClient}>
        <AdminAuthProvider>
          <UserAuthProvider>
            <BrowserRouter>
              <Suspense fallback={<h6></h6>}>
                <Routes>
                  <Route
                    path={LOGIN}
                    element={
                      <>
                        <UserProtected Component={Login} />
                      </>
                    }
                  ></Route>
                  {/* <Route
                    path={REGISTER}
                    element={
                      <>
                        <UserProtected Component={Register} />
                      </>
                    }
                  ></Route> */}
                  <Route
                    path={PASSWORDSETUP}
                    element={
                      <>
                        <UserProtected Component={PasswordSetup} />
                      </>
                    }
                  ></Route>
                  <Route
                    path={ONBOARDINGSETUP}
                    element={
                      <>
                        <UserProtected Component={OnboardingSetup} />
                      </>
                    }
                  ></Route>
                  <Route
                    path={USERTEAMPASSWORDSETUP}
                    element={
                      <>
                        <UserProtected Component={UserTeamPasswordSetup} />
                      </>
                    }
                  ></Route>
                  <Route
                    path={FORGOT_PASSWORD}
                    element={
                      <>
                        <UserProtected Component={ForgotPassword} />
                      </>
                    }
                  ></Route>
                  <Route
                    path={ADMIN_LOGIN}
                    element={
                      <>
                        <AdminProtected Component={Login} />
                      </>
                    }
                  ></Route>
                  <Route
                    path={ADMIN}
                    element={
                      <>
                        <AdminProtected Component={Login} />
                      </>
                    }
                  ></Route>

                  <Route
                    path={HOME}
                    element={
                      <>
                        <UserProtected Component={Home} />
                      </>
                    }
                  ></Route>
                  <Route
                    path={INVOICE}
                    element={
                      <>
                        <UserProtected Component={Home} />
                      </>
                    }
                  ></Route>
                  <Route
                    path={INVOICE_PENDING}
                    element={
                      <>
                        <UserProtected Component={Home} />
                      </>
                    }
                  ></Route>
                  <Route
                    path={GLOBLE_SEARCH}
                    element={
                      <>
                        <UserProtected Component={Home} />
                      </>
                    }
                  ></Route>
                  <Route
                    path={INVOICE_NEED_ACTION}
                    element={
                      <>
                        <UserProtected Component={Home} />
                      </>
                    }
                  ></Route>
                  <Route
                    path={INVOICE_READY_APPROVAL}
                    element={
                      <>
                        <UserProtected Component={Home} />
                      </>
                    }
                  ></Route>
                  <Route
                    path={REPORT}
                    element={
                      <>
                        <UserProtected Component={Home} />
                      </>
                    }
                  ></Route>
                  <Route
                    path={INVOICE_VIEW}
                    element={
                      <>
                        <UserProtected Component={Home} />
                      </>
                    }
                  ></Route>
                  {/* <Route path={INV_APPROVAL} element={<><UserProtected Component={Home} /></>}></Route> */}
                  {/* <Route path={INV_APPROVAL_VIEW} element={<><UserProtected Component={Home} /></>}></Route> */}
                  <Route
                    path={INVOICE_CLAIM}
                    element={
                      <>
                        <UserProtected Component={Home} />
                      </>
                    }
                  ></Route>
                  <Route
                    path={DASHBOARD}
                    element={
                      <>
                        <UserProtected Component={Home} />
                      </>
                    }
                  ></Route>
                  <Route
                    path={ANALYTICS}
                    element={
                      <>
                        <UserProtected Component={Home} />
                      </>
                    }
                  ></Route>
                  <Route
                    path={PENDING_INFO}
                    element={
                      <>
                        <UserProtected Component={Home} />
                      </>
                    }
                  ></Route>
                  <Route
                    path={DENIED}
                    element={
                      <>
                        <UserProtected Component={Home} />
                      </>
                    }
                  ></Route>
                  <Route
                    path={FINALIZED}
                    element={
                      <>
                        <UserProtected Component={Home} />
                      </>
                    }
                  ></Route>
                  <Route
                    path={SUCCESS}
                    element={
                      <>
                        <SucessfullPage />
                      </>
                    }
                  ></Route>
                  <Route
                    path={TERMSOFUSE}
                    element={
                      <>
                        <TermOfUse />
                      </>
                    }
                  ></Route>
                  <Route
                    path={PRIVACYPOLICY}
                    element={
                      <>
                        <PrivacyPolicy />
                      </>
                    }
                  ></Route>
                  <Route
                    path={CANCLE}
                    element={
                      <>
                        <CanclePage />
                      </>
                    }
                  ></Route>
                  <Route
                    path={TEAM}
                    element={
                      <>
                        <UserProtected Component={Home} />
                      </>
                    }
                  ></Route>
                  <Route
                    path={CARD}
                    element={
                      <>
                        <UserProtected Component={Home} />
                      </>
                    }
                  ></Route>
                  <Route
                    path={BILL_HISTORY}
                    element={
                      <>
                        <UserProtected Component={Home} />
                      </>
                    }
                  ></Route>
                  <Route
                    path={STRIPE}
                    element={
                      <>
                        <UserProtected Component={Home} />
                      </>
                    }
                  ></Route>
                  <Route
                    path={HISTORY}
                    element={
                      <>
                        <UserProtected Component={Home} />
                      </>
                    }
                  ></Route>

                  <Route
                    path={CLAIM_ACTIVE_VIEW}
                    element={
                      <>
                        <UserProtected Component={Home} />
                      </>
                    }
                  ></Route>
                  <Route
                    path={FEEDBACK}
                    element={
                      <>
                        <UserProtected Component={Home} />
                      </>
                    }
                  ></Route>
                  {/* <Route path={NOTIFY} element={<><UserProtected Component={Home} /></>}></Route> */}

                  <Route
                    path={ADMIN_DASHBOARD}
                    element={
                      <>
                        <AdminProtected Component={AdminHome} />
                      </>
                    }
                  ></Route>
                  <Route
                    path={ADMIN_USER}
                    element={
                      <>
                        <AdminProtected Component={AdminHome} />
                      </>
                    }
                  ></Route>
                  <Route
                    path={ADMIN_INVOICE}
                    element={
                      <>
                        <AdminProtected Component={AdminHome} />
                      </>
                    }
                  ></Route>
                  <Route
                    path={ADMIN_COMPLETED_INVOICE}
                    element={
                      <>
                        <AdminProtected Component={AdminHome} />
                      </>
                    }
                  ></Route>
                  <Route
                    path={ADMIN_INVOICE_VIEW}
                    element={
                      <>
                        <AdminProtected Component={AdminHome} />
                      </>
                    }
                  ></Route>
                  <Route
                    path={ADMIN_INVOICE_COMPLETED_VIEW}
                    element={
                      <>
                        <AdminProtected Component={AdminHome} />
                      </>
                    }
                  ></Route>
                  <Route
                    path={ADMIN_JOB_TYPE}
                    element={
                      <>
                        <AdminProtected Component={AdminHome} />
                      </>
                    }
                  ></Route>
                  {/* <Route path={ADMIN_STATUS} element={<><AdminProtected Component={AdminHome} /></>}></Route> */}
                  <Route
                    path={ADMIN_ORDERS}
                    element={
                      <>
                        <AdminProtected Component={AdminHome} />
                      </>
                    }
                  ></Route>
                  <Route
                    path={ADMIN_PAYMENT}
                    element={
                      <>
                        <AdminProtected Component={AdminHome} />
                      </>
                    }
                  ></Route>
                  <Route
                    path={ADMIN_DELETE_PIN}
                    element={
                      <>
                        <AdminProtected Component={AdminHome} />
                      </>
                    }
                  ></Route>
                  <Route
                    path={ADMIN_NOTIFICATION}
                    element={
                      <>
                        <AdminProtected Component={AdminHome} />
                      </>
                    }
                  ></Route>
                  <Route
                    path={ADMIN_CLAIM}
                    element={
                      <>
                        <AdminProtected Component={AdminHome} />
                      </>
                    }
                  ></Route>
                  <Route
                    path={ADMIN_TEAM}
                    element={
                      <>
                        <AdminProtected Component={AdminHome} />
                      </>
                    }
                  ></Route>
                  <Route
                    path={ADMIN_VIEW_ORDERS}
                    element={
                      <>
                        <AdminProtected Component={AdminHome} />
                      </>
                    }
                  ></Route>

                  <Route
                    path={ADMIN_CLAIM_DASHBOARD}
                    element={
                      <>
                        <AdminProtected Component={AdminHome} />
                      </>
                    }
                  ></Route>
                  <Route
                    path={ADMIN_CLAIM_ACTIVE_JOB}
                    element={
                      <>
                        <AdminProtected Component={AdminHome} />
                      </>
                    }
                  ></Route>
                  <Route
                    path={ADMIN_CLAIM_COMPLETED_JOB}
                    element={
                      <>
                        <AdminProtected Component={AdminHome} />
                      </>
                    }
                  ></Route>
                  <Route
                    path={ADMIN_CLAIM_CLIENT}
                    element={
                      <>
                        <AdminProtected Component={AdminHome} />
                      </>
                    }
                  ></Route>
                  <Route
                    path={ADMIN_CLAIM_USER}
                    element={
                      <>
                        <AdminProtected Component={AdminHome} />
                      </>
                    }
                  ></Route>
                  <Route
                    path={ADMIN_CLAIM_REPORT}
                    element={
                      <>
                        <AdminProtected Component={AdminHome} />
                      </>
                    }
                  ></Route>
                  <Route
                    path={ADMIN_CLAIM_ACTIVE_JOB_VIEW}
                    element={
                      <>
                        <AdminProtected Component={AdminHome} />
                      </>
                    }
                  ></Route>
                  <Route
                    path={ADMIN_INTERNAL_NOTE_VIEW}
                    element={
                      <>
                        <AdminProtected Component={AdminHome} />
                      </>
                    }
                  ></Route>
                  <Route
                    path={ADMIN_CLAIM_COMPLETED_JOB_VIEW}
                    element={
                      <>
                        <AdminProtected Component={AdminHome} />
                      </>
                    }
                  ></Route>
                  <Route
                    path={ADMIN_FEEDBACK}
                    element={
                      <>
                        <AdminProtected Component={AdminHome} />
                      </>
                    }
                  ></Route>

                  <Route path="*" element={<NotFound />} />
                </Routes>
              </Suspense>
            </BrowserRouter>
          </UserAuthProvider>
        </AdminAuthProvider>
      </QueryClientProvider>
    </>
  );
}

export default App;
